import { Theme } from "@mui/material";
import makeStyles from '@mui/styles/makeStyles';
import createStyles from '@mui/styles/createStyles';
import { pathOr } from "ramda";

export const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        magicLabel: {
            border: `1px solid ${pathOr(
                '',
                ['palette', 'gray', 'lightGray'],
                theme
            )}`,
            borderRadius: '4px',
            padding: '10px',
            marginLeft: '12px',
            background: `${pathOr('', ['palette', 'gray', 'extraLightGray'], theme)}`,
            lineHeight: 1.8,
        },
        magicCheckBox: {
            paddingTop: theme.spacing(2),
        },
        step: {
            '& > .MuiStepLabel-root': {
                '&.Mui-disabled .MuiStepLabel-label': { color: '#000' },
                '&.Mui-disabled .MuiStepLabel-iconContainer svg': {
                    fill: 'transparent',
                    border: `1px solid ${theme.palette.purple.light}`,
                    borderRadius: '50%',
                },
                '&.Mui-disabled .MuiStepLabel-iconContainer text': {
                    fill: 'black',
                    fontWeight: 600,
                },
                '& .MuiStepLabel-iconContainer text': {
                    fill: 'white',
                    fontWeight: 600,
                },
            },
        },
        modal: {
            padding: '30px',
            paddingBottom: '24px',
            position: 'relative',
            minHeight: 200,
            fontFamily: 'Open Sans',
            '&::before': {
                position: 'absolute',
                bottom: 96,
                height: 1,
                width: '100%',
                content: "''",
                left: 0,
                backgroundColor: theme.palette.borderColor,
            },
        },
        goBackBtn: {
            top: 36,
            left: 28,
            position: 'absolute',
            justifyContent: 'flex-start',
            [theme.breakpoints.down('sm')]: {
                top: 5,
                left: 24,
            },
        },
    })
);